// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ConnectionStatus } from './connection-status';


export class ConnectionStatusMessage implements flatbuffers.IUnpackableObject<ConnectionStatusMessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):ConnectionStatusMessage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsConnectionStatusMessage(bb:flatbuffers.ByteBuffer, obj?:ConnectionStatusMessage):ConnectionStatusMessage {
  return (obj || new ConnectionStatusMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsConnectionStatusMessage(bb:flatbuffers.ByteBuffer, obj?:ConnectionStatusMessage):ConnectionStatusMessage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new ConnectionStatusMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

message():ConnectionStatus {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ConnectionStatus.Connected;
}

static startConnectionStatusMessage(builder:flatbuffers.Builder) {
  builder.startObject(1);
}

static addMessage(builder:flatbuffers.Builder, message:ConnectionStatus) {
  builder.addFieldInt16(0, message, ConnectionStatus.Connected);
}

static endConnectionStatusMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createConnectionStatusMessage(builder:flatbuffers.Builder, message:ConnectionStatus):flatbuffers.Offset {
  ConnectionStatusMessage.startConnectionStatusMessage(builder);
  ConnectionStatusMessage.addMessage(builder, message);
  return ConnectionStatusMessage.endConnectionStatusMessage(builder);
}

unpack(): ConnectionStatusMessageT {
  return new ConnectionStatusMessageT(
    this.message()
  );
}


unpackTo(_o: ConnectionStatusMessageT): void {
  _o.message = this.message();
}
}

export class ConnectionStatusMessageT implements flatbuffers.IGeneratedObject {
constructor(
  public message: ConnectionStatus = ConnectionStatus.Connected
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return ConnectionStatusMessage.createConnectionStatusMessage(builder,
    this.message
  );
}
}
